import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import Localbase from "localbase";
import { AuthContext } from "../../../context/AuthContext";
import { useParams } from "react-router-dom";
import axios from "axios";
import ENDPOINT from "../../../data/ENDPOINT";

const AssignmentLeaderboard = () => {
  const params = useParams();
  const course_url = params.course_url;
  const assignment_id = params.assignment_id; // Assuming assignment_id is passed via URL params
  const { user } = useContext(AuthContext);
  const [leaderboard, setLeaderboard] = useState([]);
  const [initialData, setInitialData] = useState([]);
  const [response, setResponse] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  let db = new Localbase("db");

  const fetchLeaderboard = async () => {
    const formData = new FormData();
    formData.append("course_url", course_url);
    formData.append("assignment_id", assignment_id);
   
    try {
      const res = await axios.post(ENDPOINT+"assignment-leaderboard.php",formData, { 
        headers: { "Content-Type": "multipart/form-data" },
      });
      const data = res.data;
      if (data.status === "success" && data.leaderboard) {
        setLeaderboard(data.leaderboard);
        setInitialData(data.leaderboard.slice(3));
        setResponse(data.leaderboard.slice(3));

        await db.collection("paths").add(
          {
            leaderboard: data.leaderboard,
          },
          "leaderboard"
        );
      } else {
        console.error("Error fetching leaderboard:", data.message);
      }
    } catch (error) {
      console.error("Error fetching leaderboard:", error);
    }
  };

  useEffect(() => {
    // Check local storage first
    db.collection("paths")
      .doc("leaderboard")
      .get()
      .then((doc) => {
        if (doc && doc.leaderboard) {
          setLeaderboard(doc.leaderboard);
          setInitialData(doc.leaderboard);
          setResponse(doc.leaderboard);
        }
      })
      .catch((error) => {
        console.error("Error fetching data from Localbase", error);
      });

    // Fetch from API
    fetchLeaderboard();
  }, []);

  const handleSearch = (e) => {
    const rawValue = e.target.value;
    setSearchTerm(rawValue);

    const term = rawValue.toLowerCase();
    console.log(term);

    if (initialData) {
      const filteredData = initialData.filter((item) => {
        return (
          item.first_name.toLowerCase().includes(term) ||
          item.last_name.toLowerCase().includes(term) ||
          item.username.toLowerCase().includes(term)
        );
      });
      setResponse(filteredData);
    }
  };

  return (
    <LeaderboardContainer>
        <h1 className="text-center mb-1">Assignment Leaderboard</h1>
        <p className="text-center text-white mb-4">Top performers in this assignment</p>
    
      {Array.isArray(leaderboard) && leaderboard.length > 0 ? (
        <TopThreeWrapper>
          {/* 2nd Place */}
          {leaderboard[1] && (
            <TopUserCard rank={2}>
              <AvatarBorder rank={2}>
                <AvatarImg
                  src={leaderboard[1].profile_pic}
                  alt={leaderboard[1].first_name}
                />
              </AvatarBorder>
              <TopName rank={2}>{leaderboard[1].first_name}</TopName>
              <TopScore rank={2}>{leaderboard[1].marks}</TopScore>
            </TopUserCard>
          )}
          {/* 1st Place */}
          {leaderboard[0] && (
            <TopUserCard rank={1} style={{ zIndex: 1 }}>
              <CrownIcon />
              <AvatarBorder rank={1}>
                <AvatarImg
                  src={leaderboard[0].profile_pic}
                  alt={leaderboard[0].first_name}
                />
              </AvatarBorder>
              <TopName rank={1}>{leaderboard[0].first_name}</TopName>
              <TopScore rank={1}>{leaderboard[0].marks}</TopScore>
            </TopUserCard>
          )}
          {/* 3rd Place */}
          {leaderboard[2] && (
            <TopUserCard rank={3}>
              <AvatarBorder rank={3}>
                <AvatarImg
                  src={leaderboard[2].profile_pic}
                  alt={leaderboard[2].first_name}
                />
              </AvatarBorder>
              <TopName rank={3}>{leaderboard[2].first_name}</TopName>
              <TopScore rank={3}>{leaderboard[2].marks}</TopScore>
            </TopUserCard>
          )}
        </TopThreeWrapper>
      ) : null}

        <SearchBarWrapper>
        <AnimatedSearchBar
          type="text"
          placeholder="Search students by name or username…"
          value={searchTerm}
          onChange={handleSearch}
        />
        <SearchIcon>
          <svg width="24" height="24" fill="none">
            <circle cx="11" cy="11" r="8" stroke="#27e89d" strokeWidth="2" />
            <path
              d="M20 20L16.65 16.65"
              stroke="#27e89d"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </SearchIcon>
      </SearchBarWrapper>
      {leaderboard ? (
        <OthersSection className="col-lg-6 col-md-6 col-sm-12 col-12">
          {response.map((user, idx) => (
            <UserRow key={user.user_id}>
              <div>
                <h6 className="text-warning me-2">#{idx + 4}</h6>
              </div>
              <OtherAvatar src={user.profile_pic} alt={user.first_name} />
              <OtherNameBlock>
                <OtherName>
                  {user.first_name} {user.last_name}
                </OtherName>
                <OtherUsername>@{user.username}</OtherUsername>
              </OtherNameBlock>
              <OtherScore>
                <span className="text-white p">Points: </span>
                {user.marks || 0}
              </OtherScore>
            </UserRow>
          ))}
        </OthersSection>
      ) : null}
    </LeaderboardContainer>
  );
};

export default AssignmentLeaderboard;

const LeaderboardContainer = styled.div`
  min-height: 100vh;
  background: #1a1a2e;
  font-family: "Poppins", sans-serif;
  color: #fff;
  padding: 32px 0;
`;

const TopThreeWrapper = styled.div`
  background: #23233f;
  border-radius: 32px;
  max-width: 600px;
  margin: 0 auto 32px auto;
  padding: 28px 0 26px 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 14px;
  box-shadow: 0 6px 24px 0 rgba(20, 23, 71, 0.16);
`;

const TopUserCard = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  position: relative;
  min-width: 120px;
  min-height: ${(props) => (props.rank === 1 ? "200px" : "170px")};
`;

const AvatarBorder = styled.div`
  background: ${(props) =>
    props.rank === 1
      ? "linear-gradient(135deg, #ffdb7a, #ffb800)"
      : props.rank === 2
      ? "linear-gradient(135deg, #679cff, #2e4fff)"
      : "linear-gradient(135deg, #b6ffd7, #2ee69d)"};
  border-radius: 50%;
  padding: ${(props) => (props.rank === 1 ? "6px" : "3.5px")};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: ${(props) => (props.rank === 1 ? "0" : "0")};
  position: relative;
  width: ${(props) => (props.rank === 1 ? "88px" : "64px")};
  height: ${(props) => (props.rank === 1 ? "88px" : "64px")};
`;

const AvatarImg = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  background: #fff;
`;

const CrownIcon = styled(EmojiEventsIcon)`
  && {
    color: #ffb800;
    font-size: 2.6rem;
    position: absolute;
    top: -42px;
    left: 50%;
    transform: translateX(-50%);
    filter: drop-shadow(0 2px 6px #0006);
  }
`;

const TopName = styled.div`
  margin-top: ${(props) => (props.rank === 1 ? "14px" : "10px")};
  font-size: ${(props) => (props.rank === 1 ? "1.18rem" : "1rem")};
  font-weight: 600;
  text-align: center;
`;

const TopScore = styled.div`
  color: ${(props) =>
    props.rank === 1
      ? "#ffb800"
      : props.rank === 2
      ? "#4b9fff"
      : "#27e89d"};
  font-size: ${(props) => (props.rank === 1 ? "1.35rem" : "1.07rem")};
  font-weight: 700;
  text-align: center;
`;

const OtherUsername = styled.div`
  font-size: 0.83rem;
  color: #7c7da2;
`;

const OthersSection = styled.div`
  background: #23233f;
  border-radius: 32px;
  margin: 0 auto;
  padding: 28px 0 8px 0;
`;

const UserRow = styled.div`
  display: flex;
  align-items: center;
  padding: 15px 24px 15px 24px;
  border-bottom: 1px solid #222244;
  transition: background 0.22s, box-shadow 0.22s, transform 0.5s cubic-bezier(
      .68,
      -0.55,
      .27,
      1.55
    );
  cursor: pointer;
  position: relative;
  &:last-child {
    border-bottom: none;
  }
  &:hover {
    background: #23234f;
    box-shadow: 0 8px 32px 0 rgba(39, 232, 157, 0.15);
    transform: translateY(-6px) scale(1.03) rotate(-1deg);
    z-index: 2;
    animation: bounceRow 0.7s cubic-bezier(.68,-0.55,.27,1.55);
  }
  @keyframes bounceRow {
    0% {
      transform: translateY(0) scale(1) rotate(0deg);
    }
    40% {
      transform: translateY(-12px) scale(1.04) rotate(-2deg);
    }
    60% {
      transform: translateY(-6px) scale(1.03) rotate(-1deg);
    }
    100% {
      transform: translateY(-6px) scale(1.03) rotate(-1deg);
    }
  }
`;

const OtherAvatar = styled.img`
  width: 44px;
  height: 44px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 16px;
  background: #222244;
`;

const OtherNameBlock = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

const OtherName = styled.div`
  font-size: 1rem;
  font-weight: 600;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const OtherScore = styled.div`
  font-size: 1.03rem;
  font-weight: 600;
  color: #27e89d;
  margin-right: 10px;
`;

const SearchBarWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto 32px auto;
  position: relative;
  z-index: 2;
  width: 500px;
  max-width: 90vw;
`;

const AnimatedSearchBar = styled.input`
  width: 100%;
  padding: 14px 48px 14px 20px;
  border-radius: 18px;
  border: none;
  background: linear-gradient(90deg, #23233f 60%, #1a1a2e 100%);
  color: #fff;
  font-size: 1.15rem;
  font-family: "Poppins", sans-serif;
  box-shadow: 0 4px 24px 0 rgba(39, 232, 157, 0.08);
  outline: none;
  transition: box-shadow 0.3s, background 0.3s, width 0.4s cubic-bezier(
      .68,
      -0.55,
      .27,
      1.55
    );
  border: 2px solid #23234f;
  animation: searchPulse 2.5s infinite alternate;
  &:focus {
    box-shadow: 0 8px 32px 0 rgba(39, 232, 157, 0.18);
    background: linear-gradient(90deg, #23234f 60%, #27e89d 100%);
    border: 2px solid #27e89d;
    width: 100%;
  }
  &::placeholder {
    color: #7c7da2;
    font-size: 1.08rem;
    letter-spacing: 0.5px;
    opacity: 0.9;
    transition: color 0.3s;
  }
  @keyframes searchPulse {
    0% { box-shadow: 0 4px 24px 0 rgba(39,232,157,0.08);}
    100% { box-shadow: 0 8px 32px 0 rgba(39,232,157,0.18);}
  }
`;

const SearchIcon = styled.div`
  position: absolute;
  right: 18px;
  top: 50%;
  transform: translateY(-50%);
  color: #27e89d;
  font-size: 1.5rem;
  pointer-events: none;
  transition: color 0.3s;
  animation: iconBounce 2s infinite alternate;
  display: flex;
  align-items: center;
  @keyframes iconBounce {
    0% { transform: translateY(-50%) scale(1);}
    100% { transform: translateY(-60%) scale(1.12);}
  }
`;